<form [formGroup]="editFormProduct" (ngSubmit)="onSubmit()" class="container mt-5 form-add-products">
  <div class="form-header">
    <h1>{{ 'download-support-page.products' | translate }}</h1>
  </div>
  <div class="form-group mb-5">
    <select
      class="form-control"
      id="productSelect"
      formControlName="productSelect"
      (change)="selectProduct($event.target.value)">
      <option value="">{{ 'download-support-page.select-a-product' | translate }}</option>
      <option *ngFor="let product of products" [value]="product.label">{{ product.label }}</option>
    </select>
  </div>

  <div class="form-group mb-5">
    <div class="buttons mt-5">
      <button class="buttons--btn-cancel" type="button" (click)="closeDialog()">
        <i class="agres-close"></i>
        {{ 'download-support-page.cancel' | translate }}
      </button>
      <button class="buttons--btn-save" type="button" (click)="addNewProduct()">
        <i class="agres-plus"></i>
        {{ 'download-support-page.new-product' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="selectedProduct || isNewProduct">
    <div class="form-group mb-5">
      <label class="mb-4" for="productName">{{ 'download-support-page.name' | translate }}:</label>
      <input type="text" id="productName" formControlName="productName" placeholder="" />
    </div>

    <div class="form-group mb-5">
      <label class="mb-4" for="productSelect">{{ 'global.support-select-category' | translate }}:</label>
      <select class="form-control" id="categorySelect" formControlName="productCategory">
        <option *ngFor="let category of categories" [value]="category.key">
          {{ category.value }}
        </option>
      </select>
    </div>

    <div class="form-group mb-5">
      <label class="mb-4" for="productPhoto"> {{ 'download-support-page.photo' | translate }}:</label>
      <p class="text-photo-extension">*{{ 'download-support-page.only-png' | translate }}</p>

      <div class="card-product">
        <img id="productImage" [src]="imageSrc" alt="product image" (click)="fileInput.click()" />
        <span class="overlay-text"> {{ 'download-support-page.click-here-to-add' | translate }}</span>
      </div>
      <input
        #fileInput
        type="file"
        formControlName="productImage"
        style="display: none"
        accept="image/*"
        (change)="previewImage($event)" />
    </div>

    <div class="buttons mt-5">
      <button
        *ngIf="isNewProduct || selectedProduct"
        [ngClass]="{ 'btn-disabled': !isValidFileType || editFormProduct.invalid || !editFormProduct.dirty }"
        [disabled]="!isValidFileType || editFormProduct.invalid || !editFormProduct.dirty"
        class="buttons--btn-save"
        type="button"
        (click)="isNewProduct ? saveProduct() : editProduct()">
        <i class="agres-upload"></i>
        {{ 'download-support-page.save' | translate }}
      </button>
      <button *ngIf="selectedProduct" class="buttons--btn-save" type="button" (click)="openModalToDeleteFile(true)">
        <i class="agres-delete"></i>
        {{ 'download-support-page.btn-delete-product' | translate }}
      </button>
      <button *ngIf="selectedProduct" class="buttons--btn-save" type="button" (click)="openModalToDeleteFile(false)">
        <i class="agres-delete"></i>
        {{ 'download-support-page.btn-delete-file' | translate }}
      </button>
    </div>
  </div>
</form>

<app-confirmar-modal
  *ngIf="showConfirmationModal"
  [(modal)]="showConfirmationModal"
  [mensagem]="confirmationModalMessage"
  [tipo]="confirmationModalType"
  [titulo]="modalTitleConfirmation"
  [confirmButtonText]="modalTranslateButtonConfirmText"
  [cancelButtonText]="modalTranslateButtonCancelText"
  (modalChange)="showConfirmationModal = $event"
  (buttonAction)="onButtonAction($event)">
</app-confirmar-modal>
